/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {defaultAutoSinistreValue} from '../../../../data/constants/Sinistres/autoMoto';
import {stringToDate} from '../../../../data/factory';
import {IError} from '../../../../data/types/interface/Sinistres/autoMoto';
import {StackParams} from '../../../../data/types/navigation';
import {sinistreService} from '../../../../services/applicatif/sinistre';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import Header from '../../../components/Header/HeaderSinistre';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal/index.web';
import {PageContainer} from '../../../components/PageContainer';
import {Form} from './FormWeb';

type NavigationProps = StackNavigationProp<StackParams, 'AutoMotoSinistre'>;

const data = {
  ...defaultAutoSinistreValue,
};

export const FAutoMotoSinistre = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState([]);
  const [dataDto, setDataDto] = useState(data);
  const [postSucces, setPostSuccess] = useState(false);
  const [IdContrat, setIdContrat] = useState('');
  const [IsLoading, setIsLoading] = useState(false);
  const {getAgence, user, utilisateurContrat} = props;
  const [listContrat, setListContrat] = useState([]);
  const [listContratSvg, setListContratSvg] = useState([]);
  const [showError, setShowError] = useState(false);
  const [messageError, setShowMessageError] = useState('');
  const numeroPolice = user.numeroPolice;
  const [isRedirection, setIsRedirection] = useState(false);

  const updateData = (user: any) => {
    dataDto.telephone = user.telephone;
    dataDto.numeroContrat = numeroPolice;
    if (numeroPolice && numeroPolice !== '') {
      setIsRedirection(true);
    } else {
      setIsRedirection(false);
    }

    return dataDto;
  };

  const getListContrat = () => {
    utilisateurContrat(
      {},
      (res: any) => {
        if (res && res.data && res.data.items) {
          setListContratSvg(res.data.items);
          const _contrats = mapAContrat(res.data.items);
          setListContrat(_contrats);
        } else {
          if (res.isError) {
            setShowMessageError(res.message);
          }
          setShowError(true);
        }
      },
      `?typeSinistre=auto_moto`,
    );
  };

  useEffect(() => {
    getListContrat();
  }, []);

  useEffect(() => {
    if (user && user.data && user.data.utilisateur) {
      const _data = updateData(user.data.utilisateur);
      setDataDto(_data);
    }
  }, [user]);

  const mapAgence = (list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.nom,
        label: e.nom,
      };
    });
    return list;
  };

  const mapAContrat = (list: any) => {
    list = list.map((e: any) => {
      return {
        value: e.numeroPolice,
        label: e.numeroPolice,
      };
    });
    return list;
  };

  useEffect(() => {
    setIsLoading(true);
    getAgence({}, (res: any) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);
        setListAgence(_list);
      }
      setIsLoading(false);
    });
  }, []);

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (response: any) => {
    setIsLoading(true);
    const _data = {...response};
    _data.dateAccident = stringToDate(response.dateAccident);
    setDataDto(_data);
    response = formDataDTO(response);
    sinistreService()
      .registerAutoMoto(response)
      .then((res: any) => {
        if (res && !res.isError && res.data) {
          res.data.data.id && setIdContrat(res.data.data.id);
          setPostSuccess(true);
        } else {
          res && setShowMessageError(res.message);
          setShowError(true);
        }
        setIsLoading(false);
      });
  };

  const formDataDTO = (data: IError) => {
    const formData = new FormData();
    data.photo.length > 0 &&
      data.photo.forEach((elt: any) => {
        formData.append('photo', elt);
      });
    data.pieceJointeAgence.length > 0 &&
      data.pieceJointeAgence.forEach((elt: any) => {
        formData.append('pieceJointeAgence', elt);
      });
    formData.append('numeroContrat', data.numeroContrat);
    formData.append('immatriculation', data.immatriculation);
    formData.append('agence', data.agence);
    formData.append('dateAccident', data.dateAccident);
    formData.append('telephone', data.telephone);
    formData.append('circonstanceAccident', data.circonstanceAccident);

    return formData;
  };

  const navigationSuccess = () => {
    setPostSuccess(false);
    navigate('MonEspace');
  };

  return (
    <View>
      <HeaderScreen
        title="Déclarer un sinistre"
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {postSucces && (
          <ConfirmationModal
            title="Votre demande a été prise en compte"
            content="Nous reviendrons éventuellement vers vous pour des compléments d'information"
            btn1="OK"
            handleBtn1={navigationSuccess}
          />
        )}
        {showError && (
          <ConfirmationModal
            title="Erreur"
            content={messageError}
            btn1="OK"
            handleBtn1={() => setShowError(false)}
          />
        )}
        {IsLoading && <Loader />}
        {!IsLoading && !postSucces && <Header isAutoMoto={true} />}
        {!postSucces && !IsLoading && (
          <Form
            isRedirection={isRedirection}
            data={dataDto}
            listAgence={listAgence}
            listContrat={listContrat}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
            listContratSvg={listContratSvg}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const AutoMotoSinistre: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FAutoMotoSinistre);
